import { c as _c } from "react/compiler-runtime";
import type { Rule, RuleAction } from '@onefootprint/request-types/dashboard';
import { cx } from 'class-variance-authority';
import { useTranslation } from 'react-i18next';
import RuleRow from '@/entities/components/details/components/content/components/rule-row';
type ContentProps = {
  ruleResults: Partial<Record<RuleAction, Rule[]>>;
  showTriggered: boolean;
};
const Content = t0 => {
  const $ = _c(17);
  const {
    ruleResults,
    showTriggered
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "classicOnboardings.rules"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  if ($[1] !== t) {
    t2 = action => {
      if (action === "pass_with_manual_review") {
        return t(_temp);
      }
      if (action === "manual_review") {
        return t(_temp2);
      }
      if (action === "fail") {
        return t(_temp3);
      }
      if (action.includes("step_up")) {
        return t(_temp4);
      }
    };
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const getRuleActionText = t2;
  let t3;
  if ($[3] !== t) {
    t3 = action_0 => {
      if (action_0 === "step_up.identity") {
        return t(_temp5);
      }
      if (action_0 === "step_up.proof_of_address") {
        return t(_temp6);
      }
      if (action_0 === "step_up.identity_proof_of_ssn") {
        return t(_temp7);
      }
      if (action_0 === "step_up.identity_proof_of_ssn_proof_of_address") {
        return t(_temp8);
      }
    };
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const getStepUpActionText = t3;
  let t4;
  if ($[5] !== getRuleActionText || $[6] !== getStepUpActionText) {
    t4 = action_1 => {
      const actionText = <span className={cx("text-label-2 text-info", {
        "text-success": action_1 === "pass_with_manual_review",
        "text-warning": action_1 === "manual_review",
        "text-error": action_1 === "fail"
      })}>{getRuleActionText(action_1)}</span>;
      if (action_1.includes("step_up")) {
        return <div className="flex gap-1 items-center">{actionText}<span className="text-label-2 text-secondary">{getStepUpActionText(action_1)}</span></div>;
      }
      return actionText;
    };
    $[5] = getRuleActionText;
    $[6] = getStepUpActionText;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const renderRuleAction = t4;
  if (Object.keys(ruleResults).length === 0) {
    let t5;
    if ($[8] !== showTriggered || $[9] !== t) {
      t5 = showTriggered ? t(_temp9) : t(_temp10);
      $[8] = showTriggered;
      $[9] = t;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    let t6;
    if ($[11] !== t5) {
      t6 = <span className="text-body-2">{t5}</span>;
      $[11] = t5;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    return t6;
  }
  let t5;
  if ($[13] !== getRuleActionText || $[14] !== renderRuleAction || $[15] !== ruleResults) {
    t5 = <div className="flex flex-col gap-6">{Object.entries(ruleResults).map(t6 => {
        const [action_2, rules] = t6;
        return <fieldset key={action_2} className="flex flex-col gap-3" aria-label={getRuleActionText(action_2 as RuleAction)}>{renderRuleAction(action_2 as RuleAction)}<ul>{rules.map(_temp11)}</ul></fieldset>;
      })}</div>;
    $[13] = getRuleActionText;
    $[14] = renderRuleAction;
    $[15] = ruleResults;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};
export default Content;
function _temp($) {
  return $.action.passWithManualReview;
}
function _temp2($_0) {
  return $_0.action.manualReview;
}
function _temp3($_1) {
  return $_1.action.fail;
}
function _temp4($_2) {
  return $_2.action.stepUp;
}
function _temp5($_3) {
  return $_3.action.identity;
}
function _temp6($_4) {
  return $_4.action.proofOfAddress;
}
function _temp7($_5) {
  return $_5.action.identityProofOfSsn;
}
function _temp8($_6) {
  return $_6.action.identityProofOfSsnProofOfAddress;
}
function _temp9($_7) {
  return $_7.noTriggeredRules;
}
function _temp10($_8) {
  return $_8.noNotTriggeredRules;
}
function _temp11(t0, index) {
  const {
    ruleExpression
  } = t0;
  const key = ruleExpression[0]?.toString() ?? `empty-rule-${index}`;
  return <RuleRow key={key} ruleExpression={ruleExpression} />;
}